<template>
  <div class="browse-episode">
    <episode :episode="episode"/>
  </div>
</template>

<script>
import Episode from '@/components/Episode';

export default {
  components: { Episode },
  name: 'browse-episode',
  props: ['seasonNumber', 'episodeNumber'],
  data() {
    return {
      episode: this.$store.getters.episode(this.seasonNumber, this.episodeNumber)
    };
  }
};
</script>



// WEBPACK FOOTER //
// BrowseEpisode.vue?d5ad3838